import { Layout } from "antd";
import React from "react";
import ResetPassword from "../../components/Forms/ResetPassword";

const ResetPasswordPage = (props) => {
  return (
    <Layout>
      <Layout.Content>
        <ResetPassword resetToken={props.match.params.resetToken} />
      </Layout.Content>
    </Layout>
  );
};

export default ResetPasswordPage;
